<template>
	<c-modal @close="close" :title="'Extra producten bestellen'">
		<c-form ref="form" @valid="submit" class="margin-t-40" >

            <h6 class="margin-t-40 margin-b-16">Voorraad</h6>

            <c-datepicker
                :label="'Datum levering'"
                :horizontal="true"
                :icon="true"
                name="dateDelivery"
                v-model="dateDelivery"
				required
				:type="'future'">
            </c-datepicker>

            <c-custom-zipcode-address
                :label="'Bezorglocatie'"
                :addresses="addresses"
                v-model="pickUpAddress"
                name="address"
            />

			<c-select v-if="bundles"
				:label="'Bundel'"
				:horizontal="true"
				:options="bundles"
				v-model="bundle"
				:ValueName="'id'"
				name="name"
				:required="true"
				@change="getbundleproducts(bundle)">
			</c-select>

           <c-checkbox
				id="delivery-address"
				v-model="allproducts"
				:horizontal="true"
				:label="' '"
				:valueName="'id'"
				:labeltext="'name'"
				:options="[
					{name:'Losse artikelen kiezen', id:'1'},
				]">
			</c-checkbox>

			<c-checkbox v-if="products"
				:label="'Voorraad'"
				:horizontal="true"
				:options="products"
				:labeltext="'name'"
				v-model="items">
			</c-checkbox>

			<c-input
				label="Ordernummer"
				:horizontal="true"
				name="orderNumber"
				v-model="orderNumber"
				required
			/>

			<c-input
				label="Uw referentie"
				:horizontal="true"
				name="yourReference"
				v-model="yourReference"
				required
			/>

			<c-textarea
				:label="'Opmerking'"
				:horizontal="true"
				type="textarea"
				name="description"
				v-model="description"
			/>

            <div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Opslaan</c-button>
				</div>
			</div>

		</c-form>
	</c-modal>
</template>

<script>
import Form from '@mixins/Form';
import CDatepicker from '@components/form/input/Datepicker';
import CModal from '@components/Modal';
import CCustomZipcodeAddress from '@components/CustomZipcodeAddress.vue';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CDatepicker, CModal, CCustomZipcodeAddress
	},
	props: {
        edit: {
            required: false
        },
		client: {
			required: true
		},
		delivery: {
			required: false
		},
		addresses: {
			required: true,
			type: Array,
		},
    },
	data() {
		return {
			product_group: '',
			products: '',
			dateDelivery: '',
			items: [],
			pickUpAddress: {},
			allproducts: '',
			bundle: '',
			bundles: '',
			orderNumber: '',
			yourReference: '',
			description: ''
		};
	},
	watch: {
		allproducts() {
			if(this.allproducts){
				this.product = '';
				if(!this.edit){
					this.items = [];
				}
				this.getAllproducts();
			}
			else{
				this.products = ''
			}
		}
	},
	methods: {
        close() {
			this.$emit('close');
		},
		getbundleproducts(bundle_id){
			this.product = '';
			this.allproducts = 0;
			if(!this.edit){
				this.items = [];
			}

			this.$xhr.get('/api/bundles/' + bundle_id).then( ( {result}) => {
				this.products = result.available_products;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Bundelgegevens kunnen niet worden ingeladen'});
			});

		},
		getAllproducts(){
			this.bundle = '';
			this.$xhr.get('/api/clients/' + this.client.parent_client_id).then( ( {result}) => {
				this.products = result.available_products;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
			});
		},
		submit() {

			let submitData = {
				delivery_type_id: this.$constants.delivery.EXTRA_PRODUCTEN,
				date: this.dateDelivery,
				address: this.pickUpAddress,
				client_id: this.client.id,
				order_number: this.orderNumber,
				your_reference: this.yourReference,
				description: this.description
			};

			let ItemsData = {
				products: []
			};

			this.items.forEach( (component, index) => {
				ItemsData['products'][index] = {product_id: this.items[index], is_pickup: 0};
			});

			let data = Object.assign(submitData, ItemsData);

			if(this.edit){
				this.$xhr.put('/api/deliveries/' + this.delivery.id, data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Extra producten wijzigen', text: 'De extra producten zijn gewijzigd'});
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Extra producten wijzigen', text: 'Er is helaas iets fout gegaan bij het aanvragen van de extra producten'});
				});
			}
			else{
				data.carrier_id = 2;
				this.$xhr.post('/api/deliveries', data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Extra producten aanvragen', text: 'De extra producten zijn aangevraagd'});
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Extra producten aanvragen', text: 'Er is helaas iets fout gegaan bij het aanvragen van de extra producten'});
				});
			}


		},
        load(){
            this.$xhr.get('/api/clients/' + this.client.parent_client_id).then( ( {result}) => {
                this.bundles = result.bundles;

            }).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
            });

			if(this.edit){
				this.pickUpAddress = this.delivery.address;
                this.dateDelivery = this.delivery.date;
				this.orderNumber = this.delivery.order_number;
				this.yourReference = this.delivery.your_reference;
				this.allproducts = 1;
				this.description = this.delivery.description;
                this.delivery.products.forEach((component, index) =>{
                let item = this.delivery.products[index].id;


                this.items.push(item);});
			}
        }
	},
	mounted() {
		this.load();
	}
}
</script>
